import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast, Flip } from 'react-toastify';
import DepositCss from '../css/DepositCss';
import '../css/RechargePlansPage.css'; // Custom styles
import plan399 from '../images/399.jpg';
import plan599 from '../images/599.jpg';
import plan799 from '../images/799.jpg';

import { Helmet } from 'react-helmet';
import RechargePlansApi from "../Api/RechargePlans"
// import axios from 'axios'; // Ensure this is imported

export default function RechargePlansPage() {
    const [plans, setPlans] = useState([]);
    const [selectedPlan, setSelectedPlan] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const navigate = useNavigate(); // <-- Navigation hook
    useEffect(() => {
        // Simulate fetching recharge plans
        setPlans([
            { id: 1, name: 'Plan 399', description: '28 days Validity', price: 399, banner: plan399, validity: 28 },
            { id: 2, name: 'Plan 599', description: '56 days Validity', price: 599, banner: plan599, validity: 56 },
            { id: 3, name: 'Plan 799', description: '84 days Validity', price: 799, banner: plan799, validity: 84 },
        ]);
    }, []);

    const handlePlanClick = (plan) => {
        setSelectedPlan(plan);
        setShowModal(true);
    };

    // const handleConfirm = async () => {
    //     setShowModal(false);
    //     try {
    //         let data = {
    //             username: JSON.parse(localStorage.getItem('userinfo'))?.username,
    //             user_id: JSON.parse(localStorage.getItem('userinfo'))?.userId,
    //             plan_amount: selectedPlan.price,
    //             validity_days: selectedPlan.validity,
    //         }
    //         const res = await Recharge(data);
    //         if (res?.data?.status) {
    //             console.log("recharge added to user --> ");
    //         }
    //     } catch (error) {
    //         toast.error("Something went wrong", {
    //             position: "top-right",
    //             autoClose: 1500,
    //             theme: "colored",
    //             transition: Flip,
    //         });
    //     }
    //     toast.success(`Recharge with ${selectedPlan.name} confirmed!`, {
    //         position: 'top-right',
    //         autoClose: 2500,
    //         transition: Flip,
    //         theme: 'colored',
    //     });

    //     // Navigate after toast finishes
    //     setTimeout(() => {
    //         navigate('/deposit/depositMoney', {
    //             state: { amount: selectedPlan.price }
    //         });
    //     }, 500);
    // };

    const handleConfirm = () => {
        setShowModal(false);

        const data = {
            username: JSON.parse(localStorage.getItem('userinfo'))?.username,
            user_id: JSON.parse(localStorage.getItem('userinfo'))?.userId,
            plan_amount: selectedPlan.price,
            validity_days: selectedPlan.validity,
        };

        toast.success(`Recharge ${selectedPlan.name} selected!`, {
            position: 'top-right',
            autoClose: 2500,
            transition: Flip,
            theme: 'colored',
        });

        // Navigate after toast finishes
        setTimeout(() => {
            navigate('/deposit/depositMoney', {
                state: {
                    amount: selectedPlan.price,
                    rechargeData: data // pass the full object here
                }
            });
        }, 500);
    };


    return (
        <DepositCss>
            <Helmet>
                {/* Page Title */}
                <title>Recharge Plans | Matka Jantri APK Subscription Options</title>

                {/* SEO Description */}
                <meta
                    name="description"
                    content="Explore various recharge plans with different validity periods to keep your Matka Jantri APK active and up-to-date."
                />

                {/* SEO Directives */}
                <meta name="robots" content="index, follow" />

                {/* Canonical URL */}
                <link rel="canonical" href="https://app.matkajantri.com/recharge-plans" />

                {/* Favicon and icons */}
                <link rel="icon" href="/favicon.ico" type="image/x-icon" />
                <link rel="icon" type="image/png" sizes="32x32" href="/favicon-32x32.png" />
                <link rel="icon" type="image/png" sizes="16x16" href="/favicon-16x16.png" />
                <link rel="apple-touch-icon" sizes="180x180" href="/apple-touch-icon.png" />

                {/* Mobile Optimization */}
                <meta name="viewport" content="width=device-width, initial-scale=1.0" />

                {/* Open Graph */}
                <meta property="og:title" content="Recharge Plans | MatkaJantri APK Subscription Options" />
                <meta
                    property="og:description"
                    content="Explore various recharge plans with different validity periods to keep your Matka Jantri APK active and up-to-date."
                />
                <meta property="og:type" content="website" />
                <meta property="og:url" content="https://app.matkajantri.com" />
                <meta property="og:image" content="https://app.matkajantri.com/Logo.png" />
                <meta name="google-site-verification" content="d6d81656210c6db7" />
            </Helmet>

            <div className="recharge-page-container">
                {/* Back Button */}
                <div style={{ marginBottom: '20px' }}>
                    <button
                        onClick={() => navigate(-1)}
                        className="back-button"
                    >
                        <i className="fa-solid fa-chevron-left"></i>
                        Back
                    </button>
                </div>

                <h2 className="text-center mb-4">Choose a Recharge Plan</h2>

                <div className="plans-grid">
                    {plans.map(plan => (
                        <div key={plan.id} className="plan-card" onClick={() => handlePlanClick(plan)}>
                            <img src={plan.banner} alt={plan.name} className="plan-banner" />
                            <div className="plan-info">
                                <h5>{plan.name}</h5>
                                <p>{plan.description}</p>
                                <strong>₹{plan.price}</strong>
                            </div>
                        </div>
                    ))}
                </div>

                {/* Modal */}
                {showModal && selectedPlan && (
                    <div className="modal-overlay">
                        <div className="modal-content">
                            <h4>Confirm Recharge</h4>
                            <p>Do you want to continue with <strong>{selectedPlan.name}</strong>?</p>
                            <div className="modal-buttons">
                                <button className="btn btn-success" onClick={handleConfirm}>Continue</button>
                                <button className="btn btn-danger" onClick={() => setShowModal(false)}>Cancel</button>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </DepositCss>
    );
}
